import React from 'react';
import { FluentDatePicker } from '../../../../../components/FluentUI/Fluent-DatePicker';
import { makeStyles, shorthands } from '@fluentui/react-components';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  root: {
      display: "flex",
      padding: "5px",
      ...shorthands.border("1px", "solid", "#EEEEEE"),
      resize: "vertical !important",
      fontSize: "12px !important",
      color: "#4E4E4E",
      height: "36px",
      marginTop: "6px",
  },
});

function ProjectStartDate({
    handleChange,
    startDate,
    maxDate,
    errors
})
{
  const fieldStyle = useStyles();
  return (
    <FluentDatePicker 
        label="Start Date"
        placeholder="Select a Date"
        size="small"
        value={startDate}
        maxDate={maxDate}
        required={true}
        onChange={(date) => {handleChange('Start', date);}}
        componentStyle={fieldStyle.root}
        validationMessage={errors}
    />
  )
}

ProjectStartDate.propTypes = {
    handleChange: PropTypes.func.isRequired,
    startDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    errors: PropTypes.string
}

export default ProjectStartDate